"use client";
import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import slideFirst from "../../../../public/home-new-banner.png";
import slideFirstMob from "../../../../public/home-new-banner-mob.png";
import slideSecMob from "../../../../public/slide-mob2.png";
import slideThreeMob from "../../../../public/slide-mob3.png";
import slideSec from "../../../../public/slide2.png";
import slideThird from "../../../../public/slide3.png";
import Image from "next/image";
import Link from "next/link";

function SampleNextArrow(any: { className: any; style: any; onClick: any }) {
  const { className, style, onClick } = any;
  return (
    <div
      className={className}
      style={{
        ...style,
        position: "absolute",
        right: "2%",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(any: { className: any; style: any; onClick: any }) {
  const { className, style, onClick } = any;
  return (
    <div
      className={className}
      style={{ ...style, position: "absolute", left: "2%", zIndex: "9" }}
      onClick={onClick}
    />
  );
}

const HeroSlider: React.FC<any> = ({ children }) => {
  const settings = {
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 4000,
    customTransition: "1s linear",
    slidesToSlide: 1,

    nextArrow: (
      <SampleNextArrow
        className={undefined}
        style={undefined}
        onClick={undefined}
      />
    ),
    prevArrow: (
      <SamplePrevArrow
        className={undefined}
        style={undefined}
        onClick={undefined}
      />
    ),
  };
  return (
    <div className="slider-container" id="homeSlider">
      <Slider {...settings}>
        <div className="relative">
          <Image
            src={slideFirst}
            alt="slide1"
            className="w-full object-cover md:!block !hidden "
            loading="eager"
            fetchPriority="high"
            priority
          />

          <Image
            src={slideFirstMob}
            alt="slide1"
            className="w-full object-cover md:!hidden block "
            loading="eager"
            fetchPriority="high"
            priority
          />
          <div className="absolute lg:top-[30%]  top-[20px]  lg:translate-x-[17%] translate-x-[5%] banner-cap first-bann">
            <h2 className="hero-title lg:!leading-[50px] !normal-case">
              Experience the Future of <br /> Lab Testing With Presto Next-Gen
              <br />
              Material Testing Solutions
            </h2>
          </div>

          <div className="absolute top-16 lg:top-[60%] md:top-[50%]  banner-cap-blue">
            <div className="bg-primary-main lg:w-[700px] md:w-[400px] w-[55%] py-3 rounded-se-full rounded-ee-full">
              <h5 className="lg:text-2xl md:text-[1rem] text-[10px]  lg:translate-x-[14%] md:translate-x-[5%] translate-x-[5%] text-white">
                Presto is the World&apos;s 1<sup>st</sup> Technology{" "}
                <br className="hidden md:block" />
                driven company serving manufacturers with the{" "}
                <br className="hidden md:block" /> finest testing solutions
              </h5>
            </div>
          </div>
        </div>

        <div className="relative">
          <Image
            src={slideSec}
            alt="slide1"
            className="w-full object-cover md:!block !hidden "
            loading="eager"
            fetchPriority="high"
            priority
          />
          <Image
            src={slideSecMob}
            alt="slide1"
            className="w-full object-cover md:!hidden block "
            loading="eager"
            fetchPriority="high"
            priority
          />
          <div className="absolute top-1/2 -translate-y-[50%] lg:translate-x-[25%] translate-x-[5%] banner-cap banner-cap-sec">
            <h2 className="hero-title lg:!leading-[50px] !normal-case">
              From Far and Wide...
              <br />
              Our Expertise at Your Side
            </h2>
            <Link href="/about-us" className="md:mt-5">
              <button
                type="button"
                className=" group overflow-y-hidden mt-5 md:mt-0 bg-white md:py-3 py-1 md:px-6 px-4 border  font-semibold rounded-full flex items-center relative  before:absolute before:bottom-0 before:left-0 before:bg-orange-main before:translate-y-0 hover:before:translate-y-12 before:transition-all before:w-full before:h-full before:rounded-full"
              >
                <p className="relative flex items-center text-white hover:text-orange-main group-hover:text-orange-main  ">
                  Read More
                </p>
              </button>
            </Link>
          </div>
        </div>

        <div className="relative">
          <Image
            src={slideThird}
            alt="slide1"
            className="w-full object-cover md:!block !hidden "
            loading="eager"
            fetchPriority="high"
            priority
          />
          <Image
            src={slideThreeMob}
            alt="slide1"
            className="w-full object-cover md:!hidden block "
            loading="eager"
            fetchPriority="high"
            priority
          />

          <div className="absolute top-1/2 -translate-y-[50%] lg:translate-x-[25%] translate-x-[5%] banner-cap banner-cap-sec">
            <h2 className="hero-title !text-center lg:!leading-[45px] !normal-case">
              Legacy of Precision
            </h2>

            <h2 className="hero-title !text-center lg:!leading-[40px] !normal-case">
              Your Trusted Partner in <br /> Timeless Material Testing
            </h2>
          </div>
        </div>
      </Slider>
    </div>
  );
};

export default HeroSlider;
